import React,{useEffect,useState} from "react";
import { Hooks,Context,Util } from "@xt/xtbase";
const {useTranslation} = Hooks;
const {XtContext} = Context;
const {getUrl} = Util;
import styles from "./index.module.less";
import { observer } from 'mobx-react-lite';
import guideArrow from "@/assets/icon-svg/guideArrow.svg";
import SvgIcon from "@xt/SvgIcon";

const HomeGuide = () => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { theme, loginStatus} = appState;
  const isLogin = loginStatus == 1;
  const router = {
    sign: getUrl("/accounts/register"),
    deposit: getUrl("/otc/index"),
    trade: getUrl("/trade/btc_usdt"),
  }
  const items = {
    actions: [
      {
        number: "01",
        class: "sign",
        name: "sign",
        icon: "sign",
        text: t("home.signUp"),
        describe: t("home.SIGNDesc"),
        action: {
          show: !isLogin,
          value: t("home.coinSubmitTip1"),
        },
      },
      {
        number: "02",
        class: "deposit",
        name: "deposit",
        icon: "deposit",
        text: t("home.deposit"),
        describe: t("home.DEPOSITDesc"),
        action: {
          show: isLogin,
          value: t("home.coinSubmitTip1"),
        },
      },
      {
        number: "03",
        class: "trade",
        name: "trade",
        icon: "trade",
        text: t("home.TRADE"),
        describe: t("home.TRADEDesc"),
        action: {
          show: isLogin,
          value: t("home.coinSubmitTip1"),
        },
      },
    ],
  };
  const isAction = (index) => {
    if (index === 0) {
      return !isLogin;
    } else {
      return isLogin;
    }
  }
  const [step,setStep] = useState(1);
  const [moving, setMoving] = useState(0);
  const scrollRef = React.useRef();
  var startX = -1;
  const onTouchStart = (e)=>{
    if(moving != 0)
      return;
    startX = e.touches[0].clientX;
  }
  const onTouchMove = (e)=>{
    if(moving != 0)
      return;
    var x = e.touches[0].clientX;
    var m = 0;
    if(x-startX < -10 && step < 3)
      m = 1;
    else if(x-startX > 10 && step > 1)
      m = -1;
    else
      return;
    setMoving(m);
    scrollRef.current.style.marginLeft = (1-(step+m))*100+"%";
    setTimeout(()=>{
      setMoving(0);
      setStep(step+m);
    },500);
  }
  const onTouchEnd = (e)=>{
    startX = -1;
  }
  React.useEffect(()=>{
    scrollRef.current.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, { passive: false });
  },[]);
  return <div className={`home-guide-container ${styles["home-guide-container"]}`}>
    <h2 className={`${styles["guide-title"]} ${styles["font-family-black"]}`}>
      {t("home.beginTitle")}
    </h2>
    <div className={`home-guide-container-step ${styles["guide-step"]}`}>
      {items.actions.map((item, index) => {
        return <div className={`${styles["guide-child"]} ${styles[item.class]}`} key={"home_guide_" + index}>
          <div className={`${styles["guide-number"]} ${styles["font-family-black"]}`}>
            {item.number}
          </div>
          <div className={styles["guide-model"]}>
            <div className={styles["guild-value"]}>
              <div className={styles["guild-value-top"]}>
                <div className={`${styles["text"]} ${styles["font-family-bold"]}`}>{item.text}</div>
                <div className={`${styles["describe"]} ${styles["font-family-normal"]}`}>{item.describe}</div>
                {isAction(index) ? <a href={router[item.name]} className={`${styles["font-family-bold"]} ${styles["action"]} ${styles["active"]}`}>
                  {item.action.value}
                </a> : <div className={`${styles["font-family-bold"]} ${styles["action"]}`}>
                  {item.action.value}
                </div>}
              </div>
            </div>
          </div>
          {index > 0 ? <SvgIcon className={styles.guideArrow} src={guideArrow} /> : null}
        </div>
      })}
    </div>
    <div className={styles.homeGuideMB}>
      <div ref={scrollRef} className={styles.guideMBScroll} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
        {items.actions.map((item, index) => {
          return <div className={styles.guideMBStep}>
            <span>{item.number}</span>
            <p>{item.text.toUpperCase()}</p>
            <p>{item.describe}</p>
            {isAction(index) ? <a href={router[item.name]}>
              {item.action.value}
            </a> : <div>
              {item.action.value}
            </div>}
          </div>
        })}
      </div>
      <div className={styles.guideMBDots}>
        {[1,2,3].map((i)=>{
          return <span key={"guideMBDots_"+i} className={`${styles.guideMBDot} ${i==step ? styles.atv : ''}`}></span>
        })}
      </div>
    </div>
  </div>;
}
export default observer(HomeGuide);